import React from 'react'
import classNames from 'classnames'

import logoSVG from 'assets/images/logo/officemail-logo.svg'
import calendarLogoSVG from 'assets/images/logo/calendar-logo-text.svg'
import todoLogoSVG from 'assets/images/logo/todo-logo-text.svg'

import styles from './style.module.scss'

// import { getAppServices } from 'env'

interface LogoProps {
  noWrapper?: boolean
  alt?: string
  className?: string
}

const Logo: React.FC<LogoProps> = ({ noWrapper, alt, className }) => {
  const altText = alt || 'logo'

  const isCalendarPath = window.location.pathname.indexOf('/calendar') === 0
  const isTodoPath = window.location.pathname.indexOf('/todo') === 0

  let logoUrl = logoSVG
  let linkUrl = '/'

  if (isTodoPath === true) {
    logoUrl = todoLogoSVG
    linkUrl = '/todo'
  } else if (isCalendarPath === true) {
    logoUrl = calendarLogoSVG
    linkUrl = '/calendar'
  }

  if (noWrapper === true) {
    return (
      <a href={linkUrl}>
        <img src={logoUrl} alt={altText} className={classNames(className)} />
      </a>
    )
  }

  return (
    <div className={classNames(styles.logo, 'logo', className)}>
      <a href={linkUrl}>
        <img src={logoUrl} alt={altText} />
      </a>
    </div>
  )
}

export default Logo
